import { Component } from '@angular/core'

import { ModalComponent } from 'common/util.modals'
import { TranslateDirective } from 'common/locale/directives/translate.directive'
import { TranslatePipe } from 'common/locale'

@Component({
  selector: 'elements-client-not-running-modal',
  templateUrl: './elementsClientNotRunningModal.component.html',
  styleUrls: ['./elementsClientNotRunningModal.component.scss'],
  imports: [TranslateDirective, TranslatePipe],
})
export class ElementsClientNotRunningModalComponent extends ModalComponent<null, true> { }
